var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('the-nav-bar'),_c('the-app-bar'),_c('v-main',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('notification-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }